import Icon from '@material-ui/icons/Timeline';
import React from 'react';
import { Filter, ResourceList } from '../../controllers';
import { BooleanField, DateTimeField, EnumField, LinkField } from '../../fields';
import { BooleanInput, EnumInput, StaffTeamSelectInput, TeamMemberSelectInput } from '../../inputs';

export default {
  Icon,
  dialogs: {
  },
  routes: {
    list: props => (
      <ResourceList
        {...props}
      >
        <LinkField
          source="organization_id"
        />
        <EnumField
          source="journey"
        />
        <EnumField
          source="stage"
        />
        <DateTimeField
          source="created_at"
        />
        <DateTimeField
          source="updated_at"
        />
        <DateTimeField
          source="completed_at"
        />
        <LinkField
          label="Last Updated By"
          reference="users"
          source="stage_changer_id"
        />
        <BooleanField
          source="completed"
        />
        <BooleanField
          source="interrupted"
        />
      </ResourceList>
    ),
  },
  components: {
    Filter: props => (
      <Filter
        {...props}
      >
        <EnumInput
          source="journey"
        />
        <StaffTeamSelectInput
          source="staff_team_id"
        />
        <TeamMemberSelectInput
          label="Owner"
          reference="users"
          source="owner_id"
        />
        <BooleanInput
          source="completed"
        />
      </Filter>
    ),
  },
  resources: {
  },
};
